import dayjs from 'dayjs';

export const formatDate = (value, variant) => (value ? dayjs(value).format(variant) : '-');
